import * as React from "react";
import Icon from "common/icons";
// styles

const styles = require("./handlers.scss");

const MoveHandler = () => {
  return (
    <button className={styles.moveWrapper}>
      <Icon icon="INTERESTS_MOVE" />
    </button>
  );
};

export const MOVE_CLASS = styles.moveWrapper;

export default MoveHandler;
